import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Login", -1)
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col" }
const _hoisted_4 = { for: "email" }
const _hoisted_5 = { class: "p-field p-col" }
const _hoisted_6 = { for: "pw" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_10 = { class: "p-field p-col" }
const _hoisted_11 = { class: "p-field p-col" }
const _hoisted_12 = { class: "p-field p-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "p-d-flex p-jc-center" }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('login.username')), 1),
          _createVNode(_component_InputText, {
            id: "email",
            modelValue: _ctx.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
            class: "p-inputtext-sm",
            placeholder: "e.g. alex@example.com",
            type: "email",
            onKeyup: _withKeys(_ctx.login, ["enter"])
          }, null, 8, ["modelValue", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('login.password_login')), 1),
          _createVNode(_component_InputText, {
            id: "pw",
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
            class: "p-inputtext-sm",
            placeholder: "********",
            type: "password",
            onKeyup: _withKeys(_ctx.login, ["enter"])
          }, null, 8, ["modelValue", "onKeyup"])
        ])
      ]),
      (_ctx.emailChanged)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_Message, {
              severity: "warn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$store.commit('setEmailChanged', true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('login.emailChanged')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_Message, {
              severity: "error",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.error=false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(_ctx.errorMessage)), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Button, {
            class: "p-button-success p-button-outlined",
            style: {"height":"45px"},
            onClick: _ctx.toRegister,
            label: _ctx.$t('login.create_account')
          }, null, 8, ["onClick", "label"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Button, {
            class: "p-button-info p-button-outlined",
            style: {"height":"45px"},
            onClick: _ctx.resetPassword,
            label: _ctx.$t('login.forgot_pw')
          }, null, 8, ["onClick", "label"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_Button, {
            class: "p-button-success",
            onClick: _ctx.login,
            style: {"height":"45px"},
            disabled: !_ctx.readyToLogin,
            label: _ctx.$t('login.login')
          }, null, 8, ["onClick", "disabled", "label"])
        ])
      ])
    ]),
    _: 1
  }))
}